import React, { useEffect, useState, useRef, useMemo, forwardRef, useImperativeHandle } from 'react'
import TiledSelect from 'baseComponent/tiledSelect'
import Button from 'meinian-package/src/baseComponent/button'
import cls from 'classnames'
import DatePicker from 'meinian-package/src/component/datePicker'
import { sampleSourceData, SampleType } from 'component/filter/sampleFilterOptions'
import GenderAndCategory from 'component/filter/genderAndCategory/newCategory'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import Select from 'meinian-package/src/baseComponent/select'
import AddPanelSelect from 'baseComponent/select/panelSelect'
import { getSampleStatusList, SAMPLE_STATE_DATA } from 'component/waterfall.card/sampleCardExamine/common'
import { useAxios } from 'zhooks/useAxios'
import { useClickAway } from 'ahooks'
import globalData from 'meinian-package/src/common/globalData'
import DropDownClearIcon from 'meinian-package/src/baseComponent/dropDownClearIcon'
import css from './index.module.less'

function Item({ children, label }) {
  return <div className={css.date}>
    <div>{label}</div>
    {children}
  </div>
}
type DateItemProps = {
  label:string,
  startTime?:string,
  endTime?:string,
  onChange: (startTime:string, endTime:string) => void,
}
function DateItem(props:DateItemProps) {
  return <Item label={props.label}>
    <DatePicker
      wrapperStyle={{ maxWidth: 'unset' }}
      style={{ maxWidth: '163px' }}
      allowClear
      startTime={props.startTime}
      endTime={props.endTime}
      noneText="不限"
      onChange={([start, end]) => props.onChange(start, end)}
      overlayProps={{
        onClick: e => e.stopPropagation()
      }}
    />
  </Item>
}
type RowProps = {
  label:string,
  children:React.ReactNode,
}
function Row({ label, children, }:RowProps) {
  return <div className={css.row}>
    <div className={css.label}>{label}</div>
    {children}

  </div>
}

type FilterItemsProps = {
  defaultParams?:any,
  value:any,
  visible:boolean,
  displayTextClassName?:any,
  onChange:(params:any)=>void
  onVisibleChange:(visible:boolean)=>void
  onCancel:()=>void
}

function useProcess() {
  const { data = [] } = useAxios(async axios => {
    const res = await axios.get('/backend-api/zhikuan/ins/inspiration/work/platform/get-sample-process')
    return getSampleStatusList({ process: res.data })
  })
  return data
}
function usePersonOptions() {
  const { data = { creators: [], assistants: [], designer: [], sampleMaker: [], typesetter: [] } } = useAxios(async axios => {
    const res = await axios.get('/backend-api/zhikuan/mn/sample/query-sample-user-filter')
    return {
      creators: res.data.creatorList.map(m => ({ label: m.userName, value: m.userId })),
      assistants: res.data.designerAssistantList.map(m => ({ value: m.designerAssistantId, label: m.designerAssistantName })),
      designer: res.data.designerList.map(m => ({ value: m.designerId, label: m.designerName })),
      sampleMaker: res.data.sampleMakerList.map(m => ({ label: m, value: m })),
      typesetter: res.data.typesetterList.map(m => ({ label: m, value: m })),
    }
  })
  return data
}
export const Filter = forwardRef(({
  visible,
  value,
  defaultParams = {},
  onChange,
  onCancel,
  onVisibleChange,
  displayTextClassName
}:FilterItemsProps, ref) => {
  const [params, setParams] = useState<any>({})
  const { creators, assistants, designer, sampleMaker, typesetter } = usePersonOptions()
  const process = useProcess()

  const steps = useMemo(() => {
    return process?.find(m => m.value === params.processId)?.children ?? SAMPLE_STATE_DATA
  }, [process, params.processId])

  useImperativeHandle(ref, () => {
    return {
      onClear: () => {
        setParams(defaultParams)
        onChange({ ...defaultParams })
      }
    }
  })
  const merge = (newParams:any) => {
    setParams({ ...params, ...newParams })
  }

  useEffect(() => {
    setParams({ ...value })
  }, [visible, value])

  const domRef = useRef()
  useClickAway(() => {
    if (visible) {
      onCancel()
    }
  }, domRef)

  const count = useMemo(() => {
    const _params = params
    const keys = [
      ['source'],
      ['processId', 'processParam', 'state'],
      ['startTime', 'endTime'],
      ['storeTimeStart', 'storeTimeEnd'],
      ['userIdList'],
      ['designerIdList'],
      ['designerAssistantIdList'],
      ['typesetterList'],
      ['sampleMakerList'],
      ['containSubFolder'],
      ['onlyHasAnnotation'],
      ['type'],
      ['gender', 'category'],
    ]
    let _count = 0
    keys.forEach(countKey => {
      if (countKey.some(key => {
        if (Array.isArray(_params[key])) {
          return _params[key].length
        }
        if (JSON.stringify(_params[key]) === '{}') {
          return false
        }
        return _params[key]
      })) {
        _count += 1
      }
      if (!countKey.length) {
        const flatKeys = keys.flat()
        const otherKeys = Object.keys(_params).filter(_key => !flatKeys.includes(_key))
        const flag = otherKeys.some(_key => {
          if (Array.isArray(_params[_key])) {
            return _params[_key].length
          }
          if (JSON.stringify(_params[_key]) === '{}') {
            return false
          }
          return _params[_key]
        })
        if (flag) {
          _count += 1
        }
      }
    })
    return _count
  }, [params])

  const paramsState = useMemo(() => {
    if (params.state) {
      return params.state
    } if (params.processParam) {
      const processValues = String(params.processParam).split(',')
      return processValues?.[1] ? params.processParam : processValues?.[1]
    }
    return params.processParam
  }, [params.processParam, params.state])

  return <div ref={domRef}>
    <a className={cls(css.btn, displayTextClassName, 'dropDownClearIcon', { active: visible, clear: count })} onClick={() => onVisibleChange(!visible)}>
      <DropDownClearIcon
        visible={visible}
        onClear={() => {
          globalData.set('mn:sampleParams:containSubFolder', 0)
          setParams(defaultParams)
          onChange(defaultParams)
          onVisibleChange(false)
        }}
      >
        <>
          全部筛选
          {
            (count > 0) && <div className={css.number}>{count}</div>
          }
        </>
      </DropDownClearIcon>
    </a>
    <section className={cls(css.container, { [css.active]: visible })}>
      <main className={css.main}>
        <TiledSelect
          label="样衣来源"
          value={params.source}
          options={sampleSourceData}
          onChange={(val) => merge({ source: val })}
        />
        <TiledSelect
          label="样衣状态"
          options={steps}
          value={paramsState}
          onChange={(val,) => {
            if (params.processId) {
              if (val) {
                merge({ processParam: val })
              } else {
                merge({ processParam: params.processId })
              }
              return
            }
            merge({ state: val })
          }}
        >
          {(process?.length > 0)
          && <span style={{ marginRight: '40px' }}>
            样衣流程：
            <Select
              displayStyle={{ maxWidth: '156px' }}
              ulStyle={{ maxHeight: '200px' }}
              trigger="click"
              data={process}
              value={params.processId}
              onChange={val => {
                merge({ processId: val, processParam: val, state: null })
              }}
            />
            </span>}
        </TiledSelect>
        <Row label="时间筛选">
          <DateItem
            label="创建时间："
            onChange={(start, end) => merge({ startTime: start, endTime: end })}
            startTime={params.startTime}
            endTime={params.endTime}
          />
          <DateItem
            label="入库时间："
            onChange={(start, end) => merge({ storeTimeStart: start, storeTimeEnd: end })}
            startTime={params.storeTimeStart}
            endTime={params.storeTimeEnd}
          />
        </Row>
        <Row label="成员筛选">
          <Item label="创建者：">
            <AddPanelSelect
              panelLabel="成员"
              key="creator"
              options={creators ?? []}
              value={params.userIdList}
              convert={v => v}
              onChange={(v) => merge({ userIdList: v })}
            />
          </Item>
          <Item label="设计师：">
            <AddPanelSelect
              panelLabel="成员"
              key="designer"
              convert={v => v}
              options={designer ?? []}
              value={params.designerIdList}
              onChange={(v) => merge({ designerIdList: v })}
            />
          </Item>
          <Item label="设计助理：">
            <AddPanelSelect
              panelLabel="成员"
              key="designerAssistant"
              convert={v => v}
              options={assistants ?? []}
              value={params.designerAssistantIdList}
              onChange={(v) => merge({ designerAssistantIdList: v })}
            />
          </Item>
          <Item label="打版师：">
            <AddPanelSelect
              panelLabel="成员"
              key="typesetter"
              convert={v => v}
              options={typesetter ?? []}
              value={params.typesetterList}
              onChange={(v) => merge({ typesetterList: v })}
            />
          </Item>
          <Item label="样衣工：">
            <AddPanelSelect
              panelLabel="成员"
              key="sampleMaker"
              convert={v => v}
              options={sampleMaker ?? []}
              value={params.sampleMakerList}
              onChange={(v) => merge({ sampleMakerList: v })}
            />
          </Item>
        </Row>
        <Row label="过滤筛选">
          <Checkbox
            checked={params.containSubFolder}
            onChange={e => {
              const _val = e.target.checked ? 1 : 0
              merge({ containSubFolder: _val })
            }}
            style={{ marginRight: 40 }}
          >显示文件夹内容</Checkbox>
          <Checkbox
            checked={params.onlyHasAnnotation}
            onChange={e => {
              if (e.target.checked) {
                merge({ onlyHasAnnotation: 1 })
              } else {
                merge({ onlyHasAnnotation: 0 })
              }
            }}
          >只看批注样衣</Checkbox>
        </Row>
        <Row label="其它筛选">
          <Item label="样衣类型：">
            <SampleType
              placeholder="不限"
              value={params.type}
              onChange={type => merge({ type })}
            />
          </Item>
          <GenderAndCategory
            label="所属行业："
            gender={params.gender}
            value={params.category}
            onChange={(cur, root) => {
              if (cur === root) {
                merge({ gender: root, category: null })
              } else {
                merge({ gender: root, category: cur })
              }
            }}
          />
        </Row>
      </main>
      <footer className={css.footer}>
        <div className={css.footerContainer}>
          {
            !!count && <a
              className={css.btnClear}
              onClick={(e) => {
                e.stopPropagation()
                setParams(defaultParams)
              }}
            >清空筛选</a>
          }
          <Button
            style={{ width: '80px', marginRight: '8px' }}
            onClick={() => {
              onVisibleChange(false)
              onCancel()
            }}
          >取消</Button>
          <Button
            type="primary"
            style={{ width: '80px' }}
            onClick={() => {
              globalData.set('mn:sampleParams:containSubFolder', params.containSubFolder)
              onChange(params)
              onVisibleChange(false)
            }}
          >确定</Button>
        </div>
      </footer>
    </section>
  </div>
})
